import { Box, List, ListItem, Typography } from "@mui/material";

import type { FC } from "react";

export const ExosModalContent: FC = () => (
  <Box>
    <Typography fontWeight={700} variant="body2">
      Some content deserves more than an email or a post.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      EXOS let you create secure, branded landing pages that sit outside your intranet—perfect for
      long-form content, ongoing resources, or key initiatives.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      Use EXOS to:
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item" }}>
          Share detailed change narratives or program hubs
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Publish leadership messages and reference content
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>Build once and update without resending</ListItem>
      </List>
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      EXOS are easy to draft, simple to maintain, and designed to work alongside your ChangeEngine
      communications—not replace them.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      Think of them as a durable home for content your teams need to return to.
    </Typography>
    <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
      Less clutter. More clarity. One trusted place to land.
    </Typography>
  </Box>
);
